export default "__VITE_ASSET__BnOIKiQM__"